import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TvProductionTrackerService } from 'src/app/services/tv-production-tracker.service';
import { GenericService } from 'src/app/services/generic.service';
import { videoURL } from 'src/app/services/base-url';

@Component({
  selector: 'app-quality-check-workflow',
  templateUrl: './quality-check-workflow.component.html',
  styleUrls: ['./quality-check-workflow.component.css']
})
export class QualityCheckWorkflowComponent implements OnInit {

  statusMap: any = {
    'CREATED': 'Created',
    'EDITOR_ASSIGNED': 'Editor Assigned',
    'EDIT_COMPLETED': 'Edit Completed',
    'TITLE_ASSIGNED': 'Title Assigned',
    'TITLE_COMPLETED': 'Title Completed',
    'GRAPHICS_ASSIGNED': 'Graphics Assigned',
    'GRAPHICS_COMPLETED': 'Graphics Completed',
    'SEO_ASSIGNED': 'SEO Assigned',
    'SEO_COMPLETED': 'SEO Completed',
    'QUALITY_CHECK_ASSIGNED': 'Quality Check Assigned',
    'QUALITY_CHECK_COMPLETED': 'Quality Check Completed',
    'PUBLISHING_ASSIGNED': 'Publishing Assigned',
    'PUBLISHING_COMPLETED': 'Publishing Completed',
    'COMPLETED': 'Completed',
    'PENDING': 'Pending',
    'EPISODE_CREATION': 'Episode Creation'
  };

  episodeList: any = [];
  pageNumber: number = 1;
  totalRecords: number = 0;
  first: number = 0;
  tableSize: number = 10;
  isLoading: boolean = false;
  searchFilter: string = "";

  selectedEpisode: any = null;
  qcForm: any | FormGroup;
  formSubmit: boolean = false;
  cid: any;
  loggedInUserId: any;

  userList: any[] = [];
  seoUserList: any[] = [];
  editorUserList: any[] = [];
  graphicsUserList: any[] = [];
  titleUserList: any[] = [];
  selectedUserIdToAssign: any = "";
  returnStage: string = "";
  returnUserIdToAssign: any = "";
  videoUrl: any = videoURL
  userType: any = "";

  constructor(
    private tvProductionTrackerService: TvProductionTrackerService,
    private genericService: GenericService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.cid = Number(sessionStorage.getItem('cid'));
    this.loggedInUserId = Number(sessionStorage.getItem('userId')) || 0;
    this.initForm();
    this.userType = sessionStorage.getItem("userType");
    if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
      this.getAllEpisodes();
    } else {
      this.getAllTvProductionTrackersUserId();
    }

    this.getAllUsers();
  }

  getAllEpisodes() {
    this.isLoading = true;
    this.tvProductionTrackerService.getAllEpisodes().subscribe(
      (res: any) => {
        if (res && res.response) {
          this.episodeList = res.response.filter((e: any) => e.currentStage === 'QUALITY_CHECK' || e.currentStage === 'QUALITY');
          this.totalRecords = this.episodeList.length;
        } else {
          this.episodeList = [];
          this.totalRecords = 0;
        }
        this.isLoading = false;
      },
      (err: any) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  getAllUsers() {
    this.genericService.getUsersWithoutCustomers().subscribe(
      (res: any) => {
        if (res && res.response) {
          this.userList = res.response;
          this.seoUserList = this.userList.filter((u: any) => u.userType === 'SEO');
          this.editorUserList = this.userList.filter((u: any) => u.userType === 'EDITOR');
          this.graphicsUserList = this.userList.filter((u: any) => u.userType === 'GRAPHICS');
          this.titleUserList = this.userList.filter((u: any) => u.userType === 'DIRECTOR');
        }
      },
      (err: any) => {
        console.error(err);
      }
    );
  }

  initForm() {
    this.qcForm = this.fb.group({
      commonNotes: ['']
    });
  }

  getAllTvProductionTrackersUserId() {
    this.isLoading = true;
    this.tvProductionTrackerService.getAllTvProductionTrackersUserId(this.loggedInUserId).subscribe(
      (res: any) => {
        if (res && res.response) {
          this.episodeList = res.response;
          this.totalRecords = this.episodeList.length;
        } else {
          this.episodeList = [];
          this.totalRecords = 0;
        }
        this.isLoading = false;
      },
      (err: any) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page + 1;
  }

  refreshAll() {
    this.pageNumber = 1;
    this.first = 0;
    this.searchFilter = "";
    if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
      this.getAllEpisodes();
    } else {
      this.getAllTvProductionTrackersUserId();
    }
  }

  openQcModal(episode: any) {
    this.selectedEpisode = episode;
    this.qcForm.patchValue({
      commonNotes: ''
    });
    this.formSubmit = false;
    this.selectedUserIdToAssign = "";
    this.returnStage = "";
    this.returnUserIdToAssign = "";
  }

  closeModal() {
    document.getElementById("closeQcModalBtn")?.click();
    this.selectedEpisode = null;
    this.qcForm.reset();
    this.selectedUserIdToAssign = "";
    this.returnStage = "";
    this.returnUserIdToAssign = "";
  }

  saveDetails(complete: boolean, sendBackTo: string = '') {
    if (this.qcForm.invalid) {
      this.formSubmit = true;
      this.toastr.error("Please fill required fields");
      return;
    }

    let commonNotesArr = this.selectedEpisode.commonNotes || [];
    if (this.qcForm.get('commonNotes').value) {
      commonNotesArr.push({
        userId: Number(sessionStorage.getItem('userId')) || 0,
        userName: sessionStorage.getItem('userName') || '',
        commonNotes: this.qcForm.get('commonNotes').value,
        date: new Date().getTime()
      });
    }

    let nextStage = this.selectedEpisode.currentStage;
    let newStatus = this.selectedEpisode.episodeStatus;

    if (complete && this.selectedUserIdToAssign) {
      nextStage = "SEO";
      newStatus = "QUALITY_CHECK_COMPLETED";
    }

    if (sendBackTo === 'EDITOR') {
      nextStage = "EDITOR";
      newStatus = "EDITOR_ASSIGNED";
      this.selectedUserIdToAssign = ""; // Don't assign to SEO
    } else if (sendBackTo === 'GRAPHICS') {
      nextStage = "GRAPHICS";
      newStatus = "GRAPHICS_ASSIGNED";
      this.selectedUserIdToAssign = "";
    } else if (sendBackTo === 'TITLE') {
      nextStage = "TITLE";
      newStatus = "TITLE_ASSIGNED";
      this.selectedUserIdToAssign = "";
    }

    const payload: any = {
      ...this.selectedEpisode,
      commonNotes: commonNotesArr,
      episodeStatus: complete || sendBackTo ? newStatus : this.selectedEpisode.episodeStatus,
      currentStage: nextStage,
      seoUser: (complete && this.selectedUserIdToAssign) ? this.selectedUserIdToAssign : this.selectedEpisode.seoUser,
      editorUser: (sendBackTo === 'EDITOR' && this.returnUserIdToAssign) ? this.returnUserIdToAssign : this.selectedEpisode.editorUser,
      graphicsUser: (sendBackTo === 'GRAPHICS' && this.returnUserIdToAssign) ? this.returnUserIdToAssign : this.selectedEpisode.graphicsUser,
      titleCreationUser: (sendBackTo === 'TITLE' && this.returnUserIdToAssign) ? this.returnUserIdToAssign : this.selectedEpisode.titleCreationUser,
      assignedUserId: (complete && this.selectedUserIdToAssign) ? Number(this.userList.find((item: any) => item.userName === this.selectedUserIdToAssign)?.userId || 0) : (sendBackTo && this.returnUserIdToAssign ? Number(this.userList.find((item: any) => item.userName === this.returnUserIdToAssign)?.userId || 0) : (this.selectedEpisode.assignedUserId || 0)),
      assignToSEOTeamOnDate: (complete && this.selectedUserIdToAssign) ? new Date().getTime() : this.selectedEpisode.assignToSEOTeamOnDate,
      seoTeamStartDate: (complete && this.selectedUserIdToAssign) ? new Date().getTime() : this.selectedEpisode.seoTeamStartDate,
      seoDueDate: (complete && this.selectedUserIdToAssign) ? new Date().getTime() + (2 * 24 * 60 * 60 * 1000) : this.selectedEpisode.seoDueDate,
      cid: this.cid
    };
    delete payload.episodeNotes;
    delete payload.editorNotes;
    delete payload.titleNotes;
    delete payload.graphicsNotes;
    delete payload.seoNotes;
    delete payload.qualityCheckNotes;
    delete payload.publishingNotes;

    this.tvProductionTrackerService.updateEpisodeWorkflow(payload).subscribe(
      (res: any) => {
        this.toastr.success(res.message || 'Workflow updated successfully');
        if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
          this.getAllEpisodes();
        } else {
          this.getAllTvProductionTrackersUserId();
        }
        this.closeModal();
      },
      (err: any) => {
        this.toastr.error(err?.error?.errors?.[0]?.description || 'Error updating workflow');
      }
    );
  }

  isMyNote(note: any): boolean {
    if (!note || note.userId === undefined || note.userId === null) return false;
    return Number(note.userId) === Number(this.loggedInUserId);
  }

  sendChat() {
    const noteText = this.qcForm.get('commonNotes')?.value;
    if (!noteText) {
      return;
    }

    const payload = {
      userId: Number(sessionStorage.getItem('userId')) || 0,
      userName: sessionStorage.getItem('userName') || '',
      commonNotes: noteText,
      date: new Date().getTime()
    };

    this.tvProductionTrackerService.updateCommonNotes(this.selectedEpisode.tvProductionTrackerId, payload).subscribe(
      (res: any) => {
        let commonNotesArr = this.selectedEpisode.commonNotes || [];
        commonNotesArr.push(payload);
        this.selectedEpisode.commonNotes = commonNotesArr;
        this.qcForm.patchValue({ commonNotes: '' });
      },
      (err: any) => {
        this.toastr.error('Error sending chat');
      }
    );
  }
}
